"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KSVSportsdataBroker = exports.KSVSportsdataCategories = void 0;
const axios_1 = __importDefault(require("axios"));
const fixture_1 = require("./fixture");
const standing_1 = require("./standing");
const data_broker_constants_1 = require("./data-broker.constants");
const match_info_1 = require("./match-info");
var KSVSportsdataCategories;
(function (KSVSportsdataCategories) {
    KSVSportsdataCategories["fixtures"] = "fixtures";
    KSVSportsdataCategories["matchInfo"] = "match-info";
    KSVSportsdataCategories["standings"] = "standings";
})(KSVSportsdataCategories || (exports.KSVSportsdataCategories = KSVSportsdataCategories = {}));
class KSVSportsdataBroker {
    // fixtureDetailsById?: {[String]: KSVFixtureDetails}
    constructor(seasonIds) {
        this.isFetchPendingForTargetKey = new Map();
        this.isFetchCompletedForTargetKey = new Map();
        this.fetchPromiseForTargetKey = new Map();
        this.fixtures = undefined;
        this.standings = undefined;
        this.matchInfoById = new Map();
        this.seasonIds = seasonIds;
        this.endpoint = axios_1.default.create({
            baseURL: "https://hkiapp-readonly.prod-webapp-two.achtzig20-devops.de/backend/api/v1/",
        });
    }
    get isFetchPending() {
        return Array.from(this.isFetchPendingForTargetKey.values()).some(v => v === true);
    }
    fetch(targets, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [];
            // Legacy support for array of categories
            const fetchTargets = targets.map(t => {
                if (typeof t === 'object' && 'category' in t) {
                    return t;
                }
                else {
                    const target = {
                        category: t
                    };
                    return target;
                }
            });
            for (const target of fetchTargets) {
                const targetKey = target.id ? `${target.category}:${target.id}` : target.category;
                if (this.isFetchPendingForTargetKey.get(targetKey)) {
                    // Skipping fetch, already pending
                    console.log(`Skipping fetch for ${targetKey}. Already pending. Awaiting pending promise...`);
                    promises.push(this.fetchPromiseForTargetKey.get(targetKey));
                    continue;
                }
                if (this.isFetchCompletedForTargetKey.get(targetKey) && !options.force) {
                    // Skipping fetch already complete
                    console.log(`Skipping fetch for ${targetKey}. Already completed`);
                    continue;
                }
                const fetchPromise = this.fetchTarget(target, targetKey, options);
                promises.push(fetchPromise);
            }
            try {
                yield Promise.all(promises);
            }
            catch (errors) {
                console.error(errors);
            }
        });
    }
    fetchTarget(target, targetKey, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isFetchPendingForTargetKey.set(targetKey, true);
            try {
                let p;
                switch (target.category) {
                    case KSVSportsdataCategories.fixtures:
                        p = this.fetchFixtures();
                        break;
                    case KSVSportsdataCategories.standings:
                        p = this.fetchStandings();
                        break;
                    case KSVSportsdataCategories.matchInfo:
                        p = this.fetchMatchInfo(target.id);
                        break;
                }
                this.fetchPromiseForTargetKey.set(targetKey, p);
                yield p;
                this.isFetchCompletedForTargetKey.set(targetKey, true);
            }
            catch (error) {
                console.error(`Error fetching ${targetKey}`, error);
            }
            finally {
                this.isFetchPendingForTargetKey.set(targetKey, false);
            }
        });
    }
    fetchFixtures() {
        return __awaiter(this, void 0, void 0, function* () {
            // Fetch fixtures
            const matchesRes = yield Promise.all(this.seasonIds.map((sid) => this.fetchMatchesForSeason(sid)));
            const matches = matchesRes.reduce((acc, m) => [...acc, ...m.data], []).map(d => fixture_1.KSVFixture.fromData(d));
            this.fixtures = matches.sort((a, b) => a.date.getTime() - b.date.getTime());
        });
    }
    fetchMatchesForSeason(seasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.endpoint.get("matches", {
                params: { contestSeasonId: seasonId },
            });
        });
    }
    fetchStandings() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.endpoint.get("standings");
            const standingsData = res.data;
            const standings = standingsData.standings.map(d => standing_1.KSVStanding.fromData(d));
            this.standings = standings;
        });
    }
    fetchMatchInfo(matchId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.endpoint.get(`matchInfo/${matchId}`);
            const matchInfoData = res.data;
            const matchInfo = match_info_1.KSVMatchInfo.fromData(matchInfoData);
            this.matchInfoById.set(matchId, matchInfo);
        });
    }
    static instance() {
        if (!window.CMKSVSportsdataBroker) {
            console.log('Creating global broker');
            window.CMKSVSportsdataBroker = new KSVSportsdataBroker([
                data_broker_constants_1.SEASON_IDS.BUNDESLIGA.SAISON_23_24,
                data_broker_constants_1.SEASON_IDS.DFB_POKAL.SAISON_23_24
            ]);
        }
        return window.CMKSVSportsdataBroker;
    }
}
exports.KSVSportsdataBroker = KSVSportsdataBroker;
